import { render, staticRenderFns } from "./prize.vue?vue&type=template&id=1e7eb9a6&scoped=true"
import script from "./prize.vue?vue&type=script&lang=js"
export * from "./prize.vue?vue&type=script&lang=js"
import style0 from "./prize.vue?vue&type=style&index=0&id=1e7eb9a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7eb9a6",
  null
  
)

export default component.exports